import { useCancelPolicy } from "@/components/features/_hooks/use-cancel-policy/use-cancel-policy";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanCancelPolicy = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { cancelPolicy } = viewModel;

	return useCancelPolicy({ cancelPolicy, onSetViewModel });
};
